<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'AdvPortForwardingList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Advance Port Forwarding
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Adv Port Forwarding</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="AdvPortForwarding">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />

                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Type</label>
                    <div class="d-flex">
                      <label
                        class="radio mr-2 mr-md-3"
                        v-for="(type, index) in [
                          'Single Port',
                          'Multi Port',
                          'Port Range',
                        ]"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="type.toLowerCase().replace(' ', '_')"
                          v-model="value.type"
                          name="type"
                          id="type"
                          v-validate="'required'"
                          @click="initializeErrors()"
                        />
                        <span class="radio-mark"></span>{{ type }}
                      </label>
                    </div>
                    <div class="help text-danger" v-show="errors.has('type')">
                      {{ errors.first("type") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Description</label>
                    <input
                      type="text"
                      id="description"
                      name="description"
                      v-model="value.description"
                      class="form-control description"
                      placeholder="Example : Port Forwarding"
                      @keyup="setErrors($event)"
                    />
                    <div class="help text-danger">
                      {{ portErrors["description"] }}
                    </div>
                  </div>
                  <div class="form-group required" v-if="value.type == 'single_port'">
                    <label class="control-label">From Port</label>
                    <input
                      type="text"
                      id="port_from"
                      name="port_from"
                      v-model="value.port_from"
                      class="form-control port_from"
                      placeholder="Example : 8000"
                      @keyup="setErrors($event)"
                    />
                    <div class="help text-danger">
                      {{ portErrors["port_from"] }}
                    </div>
                  </div>
                  <div class="form-group required" v-if="value.type == 'single_port'">
                    <label class="control-label">To Port</label>
                    <input
                      type="text"
                      id="port_to"
                      name="port_to"
                      v-model="value.port_to"
                      class="form-control port_to"
                      placeholder="Example : 9000"
                      @keyup="setErrors($event)"
                    />
                    <div class="help text-danger">
                      {{ portErrors["port_to"] }}
                    </div>
                  </div>

                  <div class="form-group required" v-show="value.type === 'port_range'">
                    <label class="control-label">Port Range</label>
                    <input
                      type="text"
                      id="port_range"
                      name="port_range"
                      v-model="value.port_range"
                      class="form-control port_range"
                      placeholder="Example: 8000-9000"
                      @keyup="setErrors($event)"
                    />
                    <div class="help text-danger">
                      {{ portErrors["port_range"] }}
                    </div>
                  </div>

                  <div class="form-group required" v-show="value.type === 'multi_port'">
                    <label class="control-label">Multi Port</label>
                    <input
                      type="text"
                      id="multi_ports"
                      name="multi_ports"
                      v-model="value.multi_ports"
                      class="form-control multi_ports"
                      placeholder="Example: 8000,9000"
                      @keyup="setErrors($event)"
                    />
                    <div class="help text-danger">
                      {{ portErrors["multi_ports"] }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Source IP</label>
                    <input
                      type="text"
                      id="src_ip_address"
                      name="Src IP"
                      v-model="value.src_ip_address"
                      class="form-control src_ip_address"
                      placeholder="Example: 192.168.20.0/24"
                      v-validate="'required|ip_CIDR'"
                    />
                    <div class="help text-danger" v-show="errors.has('Src IP')">
                      {{ errors.first("Src IP") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">LAN Subnet</label>
                    <input
                      type="text"
                      id="lan_subnet"
                      name="lan_subnet"
                      v-model="value.lan_subnet"
                      v-validate.lazy="'ip_CIDR_MULTI'"
                      class="form-control lan_subnet"
                      placeholder="Example : 192.168.20.0/24,192.168.30.0/24"
                    />
                    <div class="help text-danger" v-show="errors.has('lan_subnet')">
                      {{ errors.first("lan_subnet") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">WAN IP</label>
                    <input
                      type="text"
                      id="wan_ip"
                      name="WAN IP"
                      v-model="value.wan_ip"
                      class="form-control wan_ip"
                      placeholder="Example : 13.13.13.199"
                      v-validate="'required|ip'"
                    />
                    <div class="help text-danger" v-show="errors.has('WAN IP')">
                      {{ errors.first("WAN IP") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Host IP</label>
                    <input
                      type="text"
                      id="host_ip_address"
                      name="Host IP"
                      v-model="value.host_ip_address"
                      class="form-control host_ip_address"
                      placeholder="Example : 192.168.221.22"
                      v-validate="'required|ip'"
                    />
                    <div class="help text-danger" v-show="errors.has('Host IP')">
                      {{ errors.first("Host IP") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Protocol</label>
                    <!-- <select
                      class="form-control"
                      style="width: 100%"
                      name="protocol"
                      v-model="value.protocol"
                      id="protocol"
                      v-validate="'required'"
                    >
                      <option value="TCP">TCP</option>
                      <option value="UDP">UDP</option>
                      <option value="BOTH">BOTH</option>
                    </select> -->
                    <div class="d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(protocol, index) in ['TCP', 'UDP', 'BOTH']"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="protocol"
                          v-model="value.protocol"
                          name="protocol"
                          v-validate="'required'"
                        />
                        <span class="radio-mark"></span>{{ protocol }}
                      </label>
                    </div>

                    <div class="help text-danger" v-show="errors.has('protocol')">
                      {{ errors.first("protocol") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "AdvPortForwardingForm",
  metaInfo: {
    title: "Adv Port Forwarding | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      type: "single_port",
      protocol: "TCP",
      multi_ports: "",
    },
    pre: {
      audraName: [],
    },
    portErrors: {
      port_from: "",
      port_to: "",
      multi_ports: "",
      port_range: "",
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;

      this.$validator.validateAll().then((result) => {
        console.log("result: ", result);
        if (result && _this.validateAll()) {
          _this.is_loading = true;
          let api_url = "/adv_port_forwardings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/adv_port_forwardings/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "AdvPortForwardingList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/adv_port_forwardings/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.src_ip_address = "0.0.0.0/0";
      }
      await CommonAPI.getAudraName(LocalStorage.get("accountId")).then((response) => {
        this.pre.audraName = response;
      });

      this.is_loading = false;

      this.setCustomValidation();
    },

    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });

      this.$validator.extend("ip_CIDR_MULTI", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24,192.168.20.0/24, ...",
        validate: (value) => {
          return this.validateIpCidrMulti(value) ? 1 : 0;
        },
      });

      // this.$validator.extend("MULTI_PORT", {
      //   getMessage: (field) =>
      //     "The input format is invalid. Valid Format : 8000,9000 ...",
      //   validate: (value) => {
      //     return this.validateMultiPort(value) ? 1 : 0;
      //   },
      // });

      // this.$validator.extend("PORT_RANGE", {
      //   getMessage: (field) => "The input format is invalid. Valid Format : 8000-9000",
      //   validate: (value) => {
      //     return this.validatePortRange(value) ? 1 : 0;
      //   },
      // });
    },

    validatePortRange(value) {
      if (!value) return 1;
      const portPattern = /^[0-9]+$/;

      const ports = value.split("-");

      if (ports.length > 2) return 0;

      for (let i = 0; i < ports.length; i++) {
        const trimmedPort = ports[i].trim();

        if (!portPattern.test(trimmedPort)) {
          return 0;
        }
      }
      return 1;
    },

    validateMultiPort(value) {
      if (!value) return 1;
      const portPattern = /^[0-9]+$/;

      const ports = value.split(",");

      for (let i = 0; i < ports.length; i++) {
        const trimmedPort = ports[i].trim();

        if (!portPattern.test(trimmedPort)) {
          return 0;
        }
      }
      return 1;
    },

    validateSinglePort(value) {
      if (!value) return 1;
      const portPattern = /^[0-9]+$/;

      if (!portPattern.test(value)) {
        return 0;
      }
      return 1;
    },
    validateIpCidrMulti(value) {
      if (!value) return 1;
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;

      const cidrs = value.split(",");

      for (let i = 0; i < cidrs.length; i++) {
        if (!ipAddressPattern.test(cidrs[i])) {
          return 0;
        }
      }

      return 1;
    },
    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },

    validateAll() {
      let validate = true;
      const portErrorsKeys = Object.keys(this.portErrors);
      for (let i = 0; i < portErrorsKeys.length; i++) {
        if (this.portErrors[portErrorsKeys[i]] != "") validate = false;
      }

      if (this.value.type == "single_port" && !this.value["port_to"]) {
        validate = false;
        this.portErrors["port_to"] = "This field is required!";
      }

      if (this.value.type == "single_port" && !this.value["port_from"]) {
        validate = false;
        this.portErrors["port_from"] = "This field is required!";
      }

      if (this.value.type == "port_range" && !this.value["port_range"]) {
        validate = false;
        this.portErrors["port_range"] = "This field is required!";
      }

      if (this.value.type == "multi_port" && !this.value["multi_ports"]) {
        validate = false;
        this.portErrors["multi_ports"] = "This field is required!";
      }

      return validate;
    },

    setErrors(event) {
      const field = event.target.name;
      console.log(field);
      if (!this.value[field]) {
        this.portErrors[field] = "This field is required!";
      } else if (field == "port_range" && !this.validatePortRange(this.value[field])) {
        this.portErrors[field] = "Invalid input format. Valid Format : 8000-9000";
      } else if (field == "multi_ports" && !this.validateMultiPort(this.value[field])) {
        this.portErrors[field] = "Invalid input format. Valid Format : 8000,9000";
      } else if (
        (field == "port_to" || field == "port_from") &&
        !this.validateSinglePort(this.value[field])
      ) {
        this.portErrors[field] = "Invalid input format. Valid Format : 8000";
      } else {
        this.portErrors[field] = "";
      }
    },

    initializeErrors() {
      this.portErrors = {
        port_from: "",
        port_to: "",
        multi_ports: "",
        port_range: "",
      };
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
